export default __webpack_public_path__ + "static/media/cover7.29b3c3c7.jpeg";